import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import Dialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const MAX_WIDTH_PERCENT_OF_IMAGE = 1;

const animationCss = config.css.animation;

const css = {
  wrapper: {
    position: "relative"
  },
  glass: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};

const CustomDialog = withStyles({
  paper: { marginLeft: 0, marginRight: 0, maxHeight: "100dvh" }
})(Dialog);

class ImageOnlyModalView extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    imageRatio: PropTypes.number.isRequired,
    imageSrc: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    removeGlass: PropTypes.bool
  };

  static defaultProps = {
    removeGlass: false
  };

  getNewImgWidth = () => {
    const { imageRatio } = this.props;
    const originalWidth = this.getWidthFromImageSrc();

    const getMaxHeight = innerHeight => {
      const deviceType = getDeviceType();
      switch (deviceType) {
        case "mobile":
          return innerHeight;
        case "desktop":
          return innerHeight - 100;

        default:
          return;
      }
    };

    const { innerHeight, innerWidth } = window;
    const maxHeight = getMaxHeight(innerHeight);
    const width1 = maxHeight * imageRatio;
    const width2 = innerWidth * MAX_WIDTH_PERCENT_OF_IMAGE;

    if (!originalWidth) return Math.min(width1, width2);
    else return Math.min(width1, width2, originalWidth);
  };

  getWidthFromImageSrc() {
    const { outfitImg } = this;
    if (!outfitImg) return null;
    return outfitImg.naturalWidth;
  }

  getInvisibleImgElement(imageSrc) {
    return (
      <img
        alt=""
        ref={ref => {
          this.outfitImg = ref;
        }}
        src={imageSrc}
        style={{ width: 0 }}
      />
    );
  }

  render() {
    const { removeGlass, open, imageSrc, onClose } = this.props;
    const width = this.getNewImgWidth();

    return (
      <div style={{ height: 0 }}>
        {this.getInvisibleImgElement(imageSrc)}
        <CustomDialog
          open={open}
          onClose={onClose}
          onClick={onClose}
          scroll="paper"
          PaperProps={{
            square: true,
            elevation: 0,
            style: { width }
          }}
          transitionDuration={animationCss.modalDurationMilliSec}
        >
          <div style={css.wrapper}>
            <img
              alt=""
              src={imageSrc}
              style={{ width: "100%", height: "auto" }}
            />
            {!removeGlass && <div style={css.glass} />}
          </div>
        </CustomDialog>
      </div>
    );
  }
}

export default ImageOnlyModalView;
